export default function notUnlimited({
    isUnlimited,
}: {
    isUnlimited: boolean;
}): boolean {
    return !isUnlimited;
}
